import { TextProps, Text as MantineText } from '@mantine/core';
import { PropsWithChildren } from 'react';
import * as React from 'react';

import { getAdaptiveWeight } from './getAdaptiveWeight';

type Props = PropsWithChildren &
  TextProps & {
    component?: 'div' | 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    dangerouslySetInnerHTML?: { __html: string };
  };

const isWindows = typeof navigator !== 'undefined' && navigator.userAgent.includes('Windows');

const Text: React.FC<Props> = ({ children, fw, component, ...props }) => {
  const adaptiveFw = isWindows ? getAdaptiveWeight(fw) : fw;

  return (
    <MantineText component={component} {...props} fw={adaptiveFw}>
      {children}
    </MantineText>
  );
};

export default Text;
